import {
	Button,
	Card,
	CardContent,
	Grid2,
	TextField,
	Typography,
} from "@mui/material";
import React from "react";
import MesfModal from "../../../../../components/modals/modal.mesf";
import { HelmetDexteel } from "../../../../../helmet/HelmetDexteel";
import { Log } from "../../models/Log";

type Props = {
	show: boolean;
	onHide: (show: boolean) => void;
	selectedLog: Log | undefined;
	suffixTitle?: string;
};

const formatTime = (nowTime: any) => {
	if (nowTime == undefined) return "";

	// Ensure nowTime is a Date object
	let date: Date;
	if (nowTime instanceof Date) {
		date = nowTime;
	} else if (typeof nowTime === "string" || typeof nowTime === "number") {
		date = new Date(nowTime);
	} else {
		return "";
	}

	// Check if date is valid
	if (isNaN(date.getTime())) {
		return "";
	}

	return date.toLocaleDateString() + " " + date.toLocaleTimeString();
};

export const ModalLogSelected = ({
	show,
	onHide,
	selectedLog,
	suffixTitle,
}: Props) => {
	return (
		<>
			{show && (
				<HelmetDexteel
					title={`${selectedLog?.Source ?? ""} - Log Details${
						suffixTitle ? ` - ${suffixTitle}` : ""
					}`}
				/>
			)}
			<Grid2 container justifyContent="center" alignItems="center">
				<MesfModal
					title="LOG DETAILS"
					open={show}
					handleClose={() => onHide(false)}
					maxWidth="md"
					id="log-details-modal"
				>
					<MesfModal.Content style={{ padding: "15px 30px" }}>
						<Grid2 container spacing={1} alignItems="flex-start">
							<Grid2
								size={{ md: 6, xs: 12 }}
								style={{ paddingRight: 20, paddingLeft: 5 }}
							>
								<TextField
									variant="standard"
									fullWidth
									margin="dense"
									label="User"
									defaultValue={selectedLog?.User}
									InputProps={{
										readOnly: true,
									}}
								/>
							</Grid2>
							<Grid2
								size={{ md: 6, xs: 12 }}
								style={{ paddingRight: 20, paddingLeft: 5 }}
							>
								<TextField
									variant="standard"
									fullWidth
									margin="dense"
									label="Time"
									defaultValue={formatTime(selectedLog?.Timestamp)}
									InputProps={{
										readOnly: true,
									}}
								/>
							</Grid2>
							<Grid2
								size={{ md: 6, xs: 12 }}
								style={{ paddingRight: 20, paddingLeft: 5 }}
							>
								<TextField
									variant="standard"
									fullWidth
									margin="dense"
									label="Source"
									defaultValue={selectedLog?.Source}
									InputProps={{
										readOnly: true,
									}}
								/>
							</Grid2>
							<Grid2
								size={{ md: 6, xs: 12 }}
								style={{ paddingRight: 20, paddingLeft: 5 }}
							>
								<TextField
									variant="standard"
									fullWidth
									margin="dense"
									label="Type"
									defaultValue={selectedLog?.LogTypeCode}
									InputProps={{
										readOnly: true,
									}}
								/>
							</Grid2>
							<Grid2
								size={{ md: 12, xs: 12 }}
								style={{ paddingRight: 20, paddingLeft: 5, marginBottom: 20 }}
							>
								<Card variant="outlined" style={{ backgroundColor: "#E9F2F8" }}>
									<CardContent>
										<Typography
											sx={{
												marginBottom: 5,
												fontSize: 12,
												color: "#0000008A",
											}}
										>
											Message:
										</Typography>
										<Typography style={{ fontSize: 17 }}>
											{selectedLog?.Message}
										</Typography>
									</CardContent>
								</Card>
							</Grid2>
						</Grid2>
					</MesfModal.Content>
					<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
						<Grid2 container spacing={2} justifyContent="flex-end">
							<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
								<Button
									fullWidth
									variant="contained"
									color="inherit"
									onClick={() => onHide(true)}
								>
									Close
								</Button>
							</Grid2>
						</Grid2>
					</MesfModal.Actions>
				</MesfModal>
			</Grid2>
		</>
	);
};
